//--------------------------------------------------------------------------
// <copyright file="FluentTextField.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import React from 'react'
import { TextField } from '@fluentui/react';

/// <summary>
/// Wrapper over the text field from microsoft fluent library.
/// </summary>
const FluentTextField = ({ setInput, input, onKeyDownFunction, placeholderText, shouldAutoFocus }) => {
  return (
    <div>
      <TextField className="Dialog-textField" autoFocus={shouldAutoFocus} onKeyDown={(e) => onKeyDownFunction(e)} autoComplete="off" value={input} underlined placeholder={placeholderText} onChange={(e) => { setInput(e.target.value) }} />
    </div>
  )
}

export default FluentTextField
